import { NextSeo } from "next-seo";
import server from "../src/api/server";
import About from "../src/components/Home/About";
import Hero from "../src/components/Home/Hero";
import Partners from "../src/components/Home/Partners";
const Services = dynamic(() => import("../src/components/Home/Services"), {
  ssr: false,
});
import Form from "../src/components/Shared/Form";
import { useIntl } from "react-intl";
import Statistics from "../src/components/Home/Statistics";
import Licens from "../src/components/Home/Licens";
import Features from "../src/components/Home/Features";
import dynamic from "next/dynamic";
const Home = ({
  heroData,
  servicesData,
  aboutData,
  partnersData,
  socialsData,
  servicesBack,
  statisticsData,
  servicesCategories,
  licensData,
  featuresData,
  metaDataSections,
}) => {
  const homeMeta = metaDataSections?.find((item) => item?.slug === "home");
  const { locale } = useIntl();
  const socials = socialsData?.filter(
    (link) =>
      ![
        "phone",
        "email",
        "location address",
        "location address_en",
        "working hours",
      ]?.includes(link?.socialType?.name?.en)
  );

  const { formatMessage } = useIntl();
  return (
    <>
      <NextSeo
        title={homeMeta?.name[locale] || formatMessage({ id: homeMeta?.slug })}
        description={
          homeMeta?.description[locale] ||
          formatMessage({ id: "Walid Ben Abdulaziz Ben mouzan" })
        }
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <Hero {...{ heroData, socials }} />
      <Statistics statisticsData={statisticsData} />
      <About {...{ aboutData }} />
      <Features featuresData={featuresData} />
      <Services {...{ servicesCategories, servicesData, servicesBack }} />
      <Partners {...{ partnersData }} />
      <Licens {...{ licensData }} />
      <Form
        formTitle={formatMessage({ id: "toAskService" })}
        formSubtitle={formatMessage({ id: "askService" })}
      />
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const heroResponse = await server.get("/pages/hero-section");
    const servicesResponse = await server.get("/pages/services");
    const metaDataResponse = await server.get("/pages/metaData");
    const statisticsResponse = await server.get("/pages/statistics/sections");
    const licensResponse = await server.get("/pages/licens/sections/licens");
    const servicesCategoriesResponse = await server.get(
      "/pages/services-categories/sections"
    );
    const aboutResponse = await server.get("/pages/about-us");
    const partnersResponse = await server.get("/pages/Partners");
    const featuresResponse = await server.get("/pages/features/sections");

    const socialsResponse = await server.get("/settings/socials");
    const teamMembersResponse = await server.get("/pages/teamMembers");
    let breadBack, contactUsBack, servicesBack, testmonialsBack;
    try {
      const backgroundResponse = await server.get("/pages/backgrounds");
      breadBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "breadcrumbs"
      )?.image;
      contactUsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "contactUs"
      )?.image;
      servicesBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "services"
      )?.image;
      testmonialsBack = backgroundResponse?.data?.data?.page?.sections?.find(
        (sec) => sec?.slug === "testmonials"
      )?.image;
    } catch (err) {
      console.log(err);
    }

    return {
      revalidate: 60,
      props: {
        heroData: heroResponse?.data?.data?.page?.sections,
        servicesData: servicesResponse?.data?.data?.page?.sections,
        aboutData: aboutResponse?.data?.data?.page?.sections,
        partnersData: partnersResponse?.data?.data?.page?.sections,
        licensData: licensResponse?.data?.data?.section,
        featuresData: featuresResponse?.data?.data?.sections,
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,

        socialsData: socialsResponse?.data?.data?.socials,
        teamMembers: teamMembersResponse?.data.data.page.sections,
        statisticsData: statisticsResponse?.data?.data?.sections,
        servicesCategories: servicesCategoriesResponse?.data?.data?.sections,
        breadBackground: breadBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${breadBack}`
          : "",
        contactUsBack: contactUsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${contactUsBack}`
          : "",
        testmonialsBack: testmonialsBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${testmonialsBack}`
          : "",
        servicesBack: servicesBack
          ? `${process.env.NEXT_PUBLIC_MAIN_URL}/${servicesBack}`
          : "",
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};
export default Home;
